import * as React from 'react';
import './index.css';
import { ItemConfigs } from '@/src/pages/channel_list/components/ShopCard/items/itemConfigs';
import { isSupportTransition } from '@/src/utils';
import { buildUrl } from '@/src/utils/buildUrl';

interface Props {
  data: any;
  lxReportOnClick?: Function;
}

interface State {
  imgTagWidth: number;
}

const WMRouter = Mach.requireModule('Router');
const imageWidth = 120;

export default class ShopCard extends React.PureComponent<Props, State> {
  customItemsConfigs: any;

  sharedElementImageRef: any = null;

  constructor(props) {
    super(props);
    this.state = {
      imgTagWidth: 1,
    };
    this.customItemsConfigs = ItemConfigs;
  }

  extraCardData = {
    shouldDynamicTagsTwoLines: true
  }

  changeExtraCardData = (extraCardData) => {
    this.extraCardData = {
      ...this.extraCardData,
      ...extraCardData
    };
  }

  gotoDetailPage(data: any) {
    if (this.props.lxReportOnClick) {
      this.props.lxReportOnClick();
    }

    let shopInfoResponse = this.props.data?.shopInfoResponse;
    shopInfoResponse = { ...shopInfoResponse, checkList: !!shopInfoResponse };
    const hasTransitionPic = shopInfoResponse?.logoUrl;
    const supportTransition = isSupportTransition(Mach.env.bundleName) && hasTransitionPic;
    const transition = supportTransition ? 1 : 0;
    if (supportTransition) {
      this.sharedElementImageRef?.didSelectedImageView?.();
    }
    WMRouter.navigateTo(buildUrl(this.props.data?.scheme, { transition }), { shopInfoResponse }, () => {});
  }

  renderLandscapeShopContent = (item, index) => {
    const landscapeJSXElements: any = [];

    let landscapeRichTextContents = [];
    let isLastItemRichTextType = false;
    // 遍历 item
    item.forEach((item, index) => {
      const { type, data } = item;
      if (this.customItemsConfigs[type]) {
        const ItemView = this.customItemsConfigs[type].view;
        const ItemModel = this.customItemsConfigs[type].model;
        const itemData = new ItemModel(data, landscapeJSXElements, landscapeRichTextContents, this.extraCardData, this.changeExtraCardData);
        if (ItemView) {
          if (isLastItemRichTextType) {
            landscapeJSXElements.push(<view>
              <rich-text className="rich-text-content" content={landscapeRichTextContents} />
            </view>);
            landscapeRichTextContents = [];
          }
          isLastItemRichTextType = false;
          landscapeJSXElements.push(<ItemView model={itemData} />);
        } else if (ItemModel && itemData.richContents) {
          landscapeRichTextContents = landscapeRichTextContents.concat(itemData.richContents(landscapeJSXElements, landscapeRichTextContents) || []);
          isLastItemRichTextType = true;
        }
      }
    });

    if (landscapeRichTextContents.length > 0) {
      landscapeJSXElements.push(<view>
        <rich-text className="rich-text-content" content={landscapeRichTextContents} />
      </view>);
    }

    if (landscapeJSXElements.length > 0) {
      return landscapeJSXElements;
    }
    return null;
  }

  render() {
    const { data } = this.props;
    const deliveryTagImg = data?.imgBottomContent?.promotionIconUrl;
    const deliveryTagText = data?.imgBottomContent?.promotionText;
    const showDeliveryImgTag = (!data?.shopStatus?.shopStatusDesc) && deliveryTagText && deliveryTagImg;
    const { imgTagWidth } = this.state;
    const shopContentVerticalData = data.content || [];
    const shopHeadImageUrl = data?.shopInfoResponse?.logoUrl;
    const height = Math.floor(Mach.env?.screenWidth * (9 / 16));
    const shopHeadImageCacheCDNParam = `${Mach.env.screenWidth * Mach.env.scale}.${height * Mach.env.scale}.100`;
    const renderSharedElementImage = isSupportTransition(Mach.env.bundleName) && shopHeadImageUrl;
    return (
      <view>
        {(
          <view className="root-container">
            <view key="card" style={{ flexDirection: 'column', padding: 8 }}>
              <view
                className="itemContainer" onClick={() => {
                  this.gotoDetailPage(data);
                }}
              >
                {/*图片+店铺信息区*/}
                <view style={{ flexDirection: 'row' }}>
                  {/*商家主图*/}
                  <view className="picturePart">
                    {renderSharedElementImage ? (
                      <shared-element-image
                        ref={(ref) => {
                          this.sharedElementImageRef = ref;
                        }}
                        cdnOptimizationSize={shopHeadImageCacheCDNParam}
                        className="interactive-transition-image"
                        resizeMode="scaleToFill"
                        placeholder="assets://placeholder/icon_placeholder_16:9.png"
                        src={
                          shopHeadImageUrl
                        }
                        error="assets://placeholder/icon_placeholder_16:9.png"
                      />
                    ) : null}
                    <image
                      className="itemImage"
                      resizeMode="aspectFill"
                      placeholder="assets://placeholder/icon_placeholder_1:1.png"
                      src={
                        data?.shopMainPicUrl != null && data?.shopMainPicUrl !== ''
                          ? data?.shopMainPicUrl
                          : 'assets://placeholder/icon_placeholder_1:1.png'
                      }
                      error="assets://placeholder/icon_placeholder_1:1.png"
                    />

                    {/* 图片区域顶部标签 */}
                    {data?.imgTopContent && (
                      <image
                        style={{ width: data?.imgTopContent?.width, height: data?.imgTopContent?.height }}
                        className="brandPic" src={data?.imgTopContent?.picUrl} resizeMode="aspectLeft"
                      />
                    )}

                    {/* 图片区域底部标签 */}
                    {(showDeliveryImgTag && (
                      <view className="bottom-tag-container">
                        <text
                          content={deliveryTagText}
                          className="bottomTag-text"
                          style={{ marginLeft: imgTagWidth + 4 }}
                        />
                      </view>
                    ))}
                    {showDeliveryImgTag && (
                      <view className="img-tag-container">
                        <image
                          resizeMode="heightFix"
                          onLayout={(size) => {
                            this.setState({
                              imgTagWidth: size.detail.width
                            });
                          }}
                          src={deliveryTagImg}
                          style={{ height: imageWidth }}
                        />
                      </view>
                    )}

                    {/*营业状态：营业中-3；休息中-4*/}
                    {data?.shopStatus?.shopStatusCode === 4 && (<view className="restBg" />)}
                  </view>

                  {/* 店铺信息区 */}
                  {this.renderShopContentArea(shopContentVerticalData)}
                </view>
              </view>

              {/* 热榜 */}
              {this.renderRecommend()}
            </view>
          </view>
        )}
      </view>
    );
  }

  private renderShopContentArea(shopContentVerticalData: any[]) {
    const topJSXElements: any = [];
    const bottomJSXElements: any = [];
    const allJSXElements: any = [];

    shopContentVerticalData.forEach((item, index) => {
      if (index === shopContentVerticalData.length - 1 && item?.[0]?.type === 'discountBar') {
        bottomJSXElements.push(
          <view key={index} className="shop-content-item-container" style={{ marginTop: 8 }}>
            {this.renderLandscapeShopContent(item, index)}
          </view>
        );
      } else {
        let marginTop = 0;
        if (index === 1) {
          marginTop = 2;
        } else if (index === 2) {
          marginTop = 8;
        }
        topJSXElements.push(
          <view key={index} className="shop-content-item-container" style={{ marginTop }}>
            {this.renderLandscapeShopContent(item, index)}
          </view>
        );
      }
    });

    if (topJSXElements.length > 0) {
      allJSXElements.push(
        <view style={{ flexDirection: 'column' }}>
          {topJSXElements}
        </view>
      );
    }
    if (bottomJSXElements.length > 0) {
      allJSXElements.push(
        <view style={{ flexDirection: 'column' }}>
          {bottomJSXElements}
        </view>
      );
    }
    let shopContentContainerStyle = {};
    if (bottomJSXElements.length > 0) {
      shopContentContainerStyle = { justifyContent: 'space-between' };
    }
    return (
      <view className="shop-content-container" style={shopContentContainerStyle}>
        {allJSXElements}
      </view>
    );
  }

  /**
   * 推荐菜
   * @returns
   */
  renderRecommend = () => {
    const { data } = this.props;
    return (
      <view>
        {data?.recommendData && (
          <view className="recommendRow">
            {data?.recommendData[0]?.renderStyle ? (
              <image-background
                resizeMode="scaleToFill"
                className="recommendRowBackground"
                src={data?.recommendData[0]?.renderStyle.backPicUrl}
              >
                <image className="recommendIcon" src={data.recommendData[0]?.renderStyle?.iconUrl} />
                <text
                  style={{
                    fontFamily: data?.recommendData[0]?.renderStyle?.fontType
                      ? data?.recommendData[0]?.renderStyle?.fontType
                      : 'Keeta-Regular',
                    fontSize: data?.recommendData[0]?.renderStyle?.fontSize
                      ? data?.recommendData[0]?.renderStyle?.fontSize
                      : 12,
                    color: data?.recommendData[0]?.renderStyle?.fontColor
                      ? data?.recommendData[0]?.renderStyle?.fontColor
                      : '#992600',
                  }}
                  className="recommendText"
                >
                  {data.recommendData[0]?.text}
                </text>
              </image-background>
            ) : null}
          </view>
        )}
      </view>
    );
  }
}
